import { useCallback } from 'react';

import qs from 'qs';

import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';
import { useSession } from 'src/app/shared/hooks/session';
import { useIsMobile } from 'src/app/shared/hooks/userAgent';

type Result = (options: { pathSuffix?: string; medium: string; additionalParams?: Record<string, string> }) => string;

export function useGenPetitionUrl(): Result {
	const session = useSession();
	const isMobile = useIsMobile();
	const {
		data: {
			initial,
			petition: { slug, bestShareVisual },
			featureConfigs: { hideRecruiter, isShareAssetsEnabled },
		},
	} = usePsfSharePageData();

	const sessionUuid = session.uuid;
	const currentUserId = session.user?.id || undefined;
	const currentCampaign = session.trackingData.current_campaign || undefined;

	return useCallback(
		({ pathSuffix, medium, additionalParams }) => {
			const shouldAddBestShareVisualParam = isShareAssetsEnabled && isMobile && !!bestShareVisual?.url;

			const trackParams = qs.stringify(
				{
					...(shouldAddBestShareVisualParam ? { best_share_visual: '1' } : {}),
					...(hideRecruiter
						? {}
						: {
								recruiter: currentUserId || undefined,
								recruited_by_id: sessionUuid,
							}),
					utm_source: 'share_petition',
					utm_campaign: initial ? 'psf_combo_share_initial' : 'psf_combo_share_message',
					utm_term: currentCampaign,
					utm_medium: medium,
					...additionalParams,
				},
				{ encodeValuesOnly: true },
			);
			return `/p/${slug}${pathSuffix || ''}?${trackParams}`;
		},
		[
			initial,
			isMobile,
			sessionUuid,
			currentUserId,
			slug,
			currentCampaign,
			hideRecruiter,
			isShareAssetsEnabled,
			bestShareVisual?.url,
		],
	);
}
